import * as React from 'react';
import * as styles from './styles.css';
import { ArticleParagraph1 } from '@cian/ui-kit';
import cn from 'clsx';

export interface IReportItemProps {
  onClick(): void;
  isActive: boolean;
  label: string;
}

export const ReportItem: React.FC<IReportItemProps> = props => {
  const { onClick, isActive, label } = props;

  return (
    <li data-testid="reportItemId" onClick={onClick} className={cn(styles['item'], { [styles['active']]: isActive })}>
      <ArticleParagraph1 color="current_color">{label}</ArticleParagraph1>
    </li>
  );
};

ReportItem.displayName = 'ReportItem';
